import { createTheme } from "@mui/material/styles";

// export const Theme = createTheme({
//   typography: {
//     fontFamily:
//       "Roboto, Helvetica Neue, Arial, sans-serif",
//     h6: {
//       fontWeight: 400,
//       fontSize: "26px",
//       color: "#193556"
//     },
//     body1: {
//       fontWeight: 400,
//       fontSize: "18px"
//     }
//   },
//   palette: {
//     custome3e:{
//       gridRow: "rgba(0, 0, 0, 0.01)" // #000000 · 1%
//     },
//     primary: {
//       main: "#193556",
//       dark: "#117CB8",
//       light: "#5CBBE5",
//       contrast: "#FFFFFF",
//       hover: "rgba(25, 53, 86, 0.04)", // #193556 · 4%
//       selected: "rgba(25, 53, 86, 0.08)", // #193556 · 8%
//       focus: "rgba(25, 53, 86, 0.12)", // #193556 · 12%
//       focusVisible: "rgba(25, 53, 86, 0.30)", // #193556 · 30%
//       outlinedBorder: "rgba(25, 53, 86, 0.50)" // #193556 · 50%
//     },
//     secondary: {
//       main: "#117CB8",
//       dark: "#193556",
//       light: "#5CBBE5",
//       contrast: "#FFFFFF",
//       hover: "rgba(17, 124, 184, 0.04)", // #117CB8 · 4%
//       selected: "rgba(17, 124, 184, 0.08)", // #117CB8 · 8%
//       focus: "rgba(17, 124, 184, 0.12)", // #117CB8 · 12%
//       focusVisible: "rgba(17, 124, 184, 0.30)", // #117CB8 · 30%
//       outlinedBorder: "#117CB8"
//     },
//     error: {
//       main: "#D74634"
//     },
//     success: {
//       main: "#51A781"
//     },
//     text: {
//       primary: "#3E3E3E",
//       secondary: "rgba(62, 62, 62, 0.60)", // #3E3E3E · 60%
//       selected: "rgba(62, 62, 62, 0.08)", // #3E3E3E · 8%
//       disabled: "rgba(62, 62, 62, 0.38)", // #3E3E3E · 38%
//       hover: "rgba(62, 62, 62, 0.04)", // #3E3E3E · 4%
//       focus: "rgba(62, 62, 62, 0.12)", // #3E3E3E · 12%
//       focusVisible: "rgba(62, 62, 62, 0.30)", // #3E3E3E · 30%
//       link: "#117CB8"
//     },
//     action: {
//       active: "rgba(0, 0, 0, 0.56)", // #000000 · 56%
//       hover: "rgba(0, 0, 0, 0.04)", // #000000 · 4%
//       selected: "rgba(0, 0, 0, 0.08)", // #000000 · 8%
//       focus: "rgba(0, 0, 0, 0.12)", // #000000 · 12%
//       disabled: "rgba(0, 0, 0, 0.38)", // #000000 · 38%
//       disabledBackground: "rgba(0, 0, 0, 0.12)" // #000000 · 12%
//     },
//     divider: "#DEDEDE"
//   },
//   components: {
//     MuiTextField: {
//       defaultProps: {
//         size: "small"
//       }
//     },
//     MuiOutlinedInput: {
//       defaultProps: {
//         size: "small"
//       }
//     },
//     MuiInputBase: {
//       defaultProps: {
//         size: "small"
//       }
//     },
//     /*
//     MuiFormLabel: {
//       styleOverrides: {
//         asterisk: ({ theme }) => ({
//           color: 'white',
//           backgroundColor: 'white',
//           '&::before': {
//             content: '" (required)"',
//             color: theme.palette.error.main,
//             backgroundColor: 'white',
//           },
//         }),
//       },
//     },
//     */
//     MuiTooltip: {
//       defaultProps: {
//         arrow: true
//       },
//       styleOverrides: {
//         tooltip: ({ theme }) => ({
//           backgroundColor: theme.palette.primary.main,
//           color: theme.palette.white,
//           maxWidth: 200,
//           whiteSpace: "normal", // allow wrapping of the text
//           boxShadow: theme.shadows[2]
//         }),
//         arrow: ({ theme }) => ({
//           "&:before": {
//             //border: `1px solid ${theme.palette.divider}`,
//           },
//           color: theme.palette.primary.main
//         })
//       }
//     }
//   }
// });

export const Theme = createTheme({
  typography: {
    fontFamily:
      'Poppins, Arial, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif',
  },
  palette: {
    e3: {
      blueDark: '#193556',
      customHover: 'rgba(25, 118, 210, 0.08)',
    },
    primary: {
      main: '#117CB8',
    },
    secondary: {
      main: '#193556',
      contrast: '#FFFFFF',
    },
    error: {
      main: '#D74634',
      dark: '#A21403',
    },
    success: {
      main: '#51A781',
    },
    text: {
      primary: '#3E3E3E',
      secondary: '#5E5E5E',
    },
    action: {
      selected: '#EEEEEE',
      hover: '#EEEEEE',
    },
    divider: '#DEDEDE',
  },
  components: {
    MuiTextField: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiOutlinedInput: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiInputBase: {
      defaultProps: {
        size: 'small',
      },
    },

    MuiFormLabel: {
      styleOverrides: {
        asterisk: ({ theme }) => ({
          color: 'white',
          backgroundColor: 'white',
          '&::before': {
            content: '""',
            color: theme.palette.error.main,
            backgroundColor: 'white',
          },
        }),
      },
    },

    MuiTooltip: {
      defaultProps: {
        arrow: true,
      },
      styleOverrides: {
        tooltip: ({ theme }) => ({
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.white,
          maxWidth: 200,
          whiteSpace: 'normal', // allow wrapping of the text
          boxShadow: theme.shadows[2],
        }),
        arrow: ({ theme }) => ({
          '&:before': {
            //border: `1px solid ${theme.palette.divider}`,
          },
          color: theme.palette.primary.main,
        }),
      },
    },

   MuiAccordion: {
  styleOverrides: {
    root: ({ theme }) => ({
      boxShadow: 'none',
      border: 'none', // remove outline
      '&:before': {
        display: 'none',
      },
      // Add a divider (bottom border) to every Accordion except the last one.
      '&:not(:last-of-type)': {
        borderBottom: `1px solid ${theme.palette.divider}`,
      },
      '&.Mui-expanded': {
        // Increase the space between the content and the bottom border
        paddingBottom: theme.spacing(2),
      },
    }),
  },
},


  },
});


export default Theme;
